import React, { forwardRef } from "react";
import classes from "./ScholarshipCard.module.scss";
import CustomImage from "../../../../CustomImage";
import { isFrappeOrJotFormClass } from "../../../../../utils/helpers";
import FeatherNote from "../../../../UI/Icons/FeatherNote";
import DollarEnclosed from "../../../../UI/Icons/DollarEnclosed";
import useIsMobile from "../../../../../hooks/useIsMobile";

const ScholarshipCard = forwardRef<HTMLDivElement, any>(({ cardData, minHeight }, ref) => {
  const isMobile = useIsMobile(768);

  return (
    <div ref={ref} className={classes.card} style={!isMobile && minHeight ? { minHeight } : undefined}>
      <div className={classes["logo-wrapper"]}>
        <CustomImage src={cardData?.image?.url ?? ""} alt="University logo" layout="fill" objectFit="contain" />
      </div>

      <div className={classes["card-content"]}>
        {cardData?.subTitle && <p className={classes.university}>{cardData?.subTitle}</p>}
        {cardData?.title && <h3 className={classes["card-title"]}>{cardData?.title}</h3>}

        <div className={classes.meta}>
          {cardData?.type && (
            <div className={classes["type-row"]}>
              <FeatherNote width={19} height={19} />
              <span>
                Scholarship Type : <strong>{cardData?.type}</strong>
              </span>
            </div>
          )}
          {cardData?.amount && (
            <div className={classes["type-row"]}>
              <DollarEnclosed width={19} height={19} />
              <span>
                Amount : <strong>{cardData?.amount}</strong>
              </span>
            </div>
          )}
        </div>

        {cardData?.description && <p className={classes.description}>{cardData?.description}</p>}
      </div>

      <button
        className={`${classes["apply-btn"]} ${cardData?.btnLink ? "" : isFrappeOrJotFormClass(cardData?.formId ?? "")}`}
        onClick={() => {
          cardData?.btnLink && window.open(cardData?.btnLink, "_blank");
        }}
      >
        {cardData?.btnLabel || "View & Apply "}
      </button>
    </div>
  );
});

export default ScholarshipCard;
